module.exports = __webpack_public_path__ + "media/icons/contacts-de996258.svg";